import { State } from './hospital-booking.state';
import { Action, ActionTypes } from './hospital-booking.actions';

const initialState: State = {
  isHospitalBooking: false,
};

export function hospitalBookingReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.SET_IS_HOSPITAL_BOOKING:
      return Object.assign({}, state, { isHospitalBooking: action.payload });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/store/hospital-booking.reducer.ts